import { combineReducers } from 'redux';
import undoable from 'redux-undo';

import Auth from './auth/reducers';
import Layout from './layout/reducers';
//import Dash from './dash/reducers';
import ChartDesigner from './chartDesigner/reducers';
import DataModelDesigner from './dataModelDesigner/reducers';
import FormBuilder from './formBuilder/reducers';
import DataSourceBuilder from './dataSourceBuilder/reducers';

import ChartDesignConditonallity from './chartDesignerConditionallity/reducers';

import DashboardPage from './dashboardPage/reducers';
import Radio from './radio/reducers';

//import DashboardPageData from './dashboardPageData/reducers';

//import DataSource from './dataSource/reducers';
//import Cube from './cube/reducers';

export default combineReducers({
    Auth,
    Layout,
    //Dash,
    DashboardPage,
    //DashboardPageData,    
    //DataSource,
    //Cube,
    Radio,
    ChartDesignConditonallity,
    ChartDesigner:undoable(ChartDesigner),
    DataModelDesigner:undoable(DataModelDesigner), 
    FormBuilder:undoable(FormBuilder),
    DataSourceBuilder:undoable(DataSourceBuilder)       
});
